import { Check, Minus } from 'lucide-react';
import { type InputHTMLAttributes, type ReactNode, useEffect, useRef } from 'react';

/**
 * A real checkbox (visually hidden) with a drawn box; the whole row is the label. `indeterminate`
 * draws a dash (some of a group on).
 */
export function Checkbox({
  label,
  indeterminate = false,
  className = '',
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: ReactNode;
  indeterminate?: boolean;
}) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return (
    <label
      className={`flex min-h-11 cursor-pointer items-center gap-3 text-sm text-text ${className}`}
    >
      <input ref={ref} type="checkbox" className="peer sr-only" {...props} />
      <span
        aria-hidden
        className={`flex size-5 shrink-0 items-center justify-center border border-accent text-accent-ink peer-checked:bg-accent peer-focus-visible:ring-2 peer-focus-visible:ring-accent/60 peer-disabled:opacity-45 [&>svg]:invisible peer-checked:[&>svg]:visible ${
          indeterminate ? 'bg-accent' : ''
        }`}
      >
        {indeterminate ? (
          <Minus className="size-4" strokeWidth={3} style={{ visibility: 'visible' }} />
        ) : (
          <Check className="size-4" strokeWidth={3} />
        )}
      </span>
      <span>{label}</span>
    </label>
  );
}
